export const EXERCISE = 'Opgave';
export const PLACEHOLDER = 'Tilføj tekst...';
export const DELETE_EXERCISE = 'Slet opgave';